import { SEO } from "@/components/SEO";
import { Navbar } from "@/components/Navbar";
import { DigitalWorkerShowcase } from "@/components/DigitalWorkerShowcase";
import { DigitalEmployeeExperienceSection } from "@/components/DigitalEmployeeExperienceSection";
import { Footer } from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "@/lib/router-compat";

const DigitalWorkers = () => {
  const { language } = useLanguage();
  const prefix = language === "en" ? "" : `/${language}`;
  const fmsLabel =
    language === "zh"
      ? "什么是 FMS / AI FMS？"
      : language === "th"
        ? "FMS และ AI FMS คืออะไร?"
        : "What is an FMS / AI FMS?";

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Freight Forwarding AI Agents | CargoNova Digital Workers"
        description="Seven freight forwarding AI agents automate AI freight quotation, booking, document OCR and settlement — the AI agent workforce inside CargoNova's AI FMS."
        canonical="https://cargonova.ai/digital-workers"
        titleZh="货代 AI 智能体 / AI 数字员工 | CargoNova"
        descriptionZh="7 个货代 AI 智能体自动完成智能报价、订舱、单证识别与费用结算，是国际货代 AI 系统中的 AI 数字员工矩阵，显著提升作业效率。"
        canonicalZh="https://cargonova.ai/zh/digital-workers"
        canonicalTh="https://cargonova.ai/th/digital-workers"
      />
      <Navbar />
      <main className="pt-20">
        <h1 className="sr-only">
          CargoNova AI Agents — CargoNova Digital Workers for Freight Forwarding
        </h1>
        <DigitalWorkerShowcase />
        <DigitalEmployeeExperienceSection />
        <div className="container mx-auto px-4 pb-12 text-center">
          <Link
            to={`${prefix}/blog/what-is-ai-fms`}
            className="text-sm font-medium text-muted-foreground hover:text-secondary transition-colors"
          >
            {fmsLabel}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DigitalWorkers;
